document.addEventListener('DOMContentLoaded', function () {
  // Helper: Get cookie by name
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  // Helper: Set cookie with expiry
  function setCookie(name, value, days) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = `${name}=${value || ""}${expires}; path=/`;
  }

  // Helper: Get URL param by name
  function getURLParameter(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }

  // ✅ Track utm_source and utm_id (but rename utm_id → uid in cart)
  const trackingParams = ['utm_source', 'utm_id'];

  // Set cookies for those found in URL
  trackingParams.forEach(param => {
    const value = getURLParameter(param);
    if (value) {
      setCookie(param, value, 30); // Cookie lasts 30 days
    }
  });

  // Read cookies and build cart attributes
  const cartAttributes = {};

  trackingParams.forEach(param => {
    const value = getCookie(param);
    if (value) {
      if (param === 'utm_id') {
        cartAttributes['uid'] = value; // 🔄 rename utm_id → uid
      } else {
        cartAttributes[param] = value;
      }
    }
  });

  // If any attributes exist, send to Shopify
  if (Object.keys(cartAttributes).length > 0) {
    const formData = {
      attributes: cartAttributes
    };

    fetch(window.routes.cart_update_url + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(res => {
      if (!res.ok) throw new Error('Network response was not ok ' + res.statusText);
      return res.json();
    })
    .then(data => {
      console.log('Cart updated with tracking attributes:', data);
    })
    .catch(error => {
      console.error('Error updating cart:', error);
    });
  }
});
